export const stringToId = str => encodeURIComponent(str.toLocaleLowerCase()
// replace :: and ' with space, which will be replaced with -
.replace(/::|'/g, ' ')
// remove : and ()
.replace(/[:()]/g, '').split(' ').join('-'));